import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../services/ApiService'
import {
  CORRECTION_IN_REQUEST,
  DATA_ALREADY_EXIST,
  EXPECTED_AMOUNT,
  LAST_BILL_MUST_PAY_DELIVERY,
  LAST_BILL_MUST_PAY_DELIVERY_INSURANCE,
  RETUR_CANNOT_BE_USED_WITH_DP,
} from '../../utility/ResponseConstant'
import { showAlert } from '../../utility/SweetAlert'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const InteractorFundBill = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [billData, setBillData] = useState([])
  const [billPage, setBillPages] = useState({
    currentPage: 1,
    limitProduct: 0,
    totalPages: 1,
    totalItem: 0,
  })
  const { account } = useSelector((state) => state.account)
  const { seller } = useSelector((state) => state.seller)
  const [billLoading, setBillLoading] = useState(false)

  const billList = useCallback(
    (payload = {}, loadingCallback = () => {}) => {
      const payloadRequest = {
        ...payload,
        keywords: { ...payload.keywords, account_uid: account.uid },
      }
      loadingCallback(true)
      ApiService.jsonRequest('/fund-bill/bank-search', payloadRequest, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          const { pages } = response.data
          setBillPages({
            currentPage: pages.page,
            limitProduct: pages.limit,
            totalPages: pages.total_pages,
            totalItem: pages.total_items,
          })
          setBillData(response.data?.items)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.uid, t],
  )

  const viewBill = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest('/fund-bill/view', payload, (response) => {
        if (response.status_code === 200) {
          if (response.data) {
            callback(response.data)
          } else {
            showAlert({
              icon: 'warning',
              message: t('response_message.send_failed'),
              timer: 2000,
              reload: true,
            })
          }
        }
        loading(false)
      })
    },
    [t],
  )

  const addBill = useCallback(
    (payload = {}, loadingCallback = () => {}) => {
      const transaction_uid = payload?.reference_uid
      const payloadRequest = {
        ...payload,
        account_uid: account.uid,
        company_uid: seller.company_uid,
        created_by: account.full_name,
      }
      delete payloadRequest.transaction_uid
      loadingCallback(true)
      ApiService.jsonRequest('/fund-bill/create', payloadRequest, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_added`),
            timer: 2000,
          })
          navigate(`/order/view?uid=${transaction_uid}`)
        } else {
          if (response.messages === DATA_ALREADY_EXIST) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 2000,
              reload: true,
            })
          } else if (response.messages === LAST_BILL_MUST_PAY_DELIVERY) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 3000,
              reload: true,
            })
          } else if (response.messages === LAST_BILL_MUST_PAY_DELIVERY_INSURANCE) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 3000,
              reload: true,
            })
          } else if (response.messages.includes(CORRECTION_IN_REQUEST)) {
            showAlert({
              icon: 'error',
              message: t(`response_message.bill_not_create_correction_in_request`),
              timer: 2000,
              reload: true,
            })
          } else if (response.messages.includes(EXPECTED_AMOUNT)) {
            showAlert({
              icon: 'error',
              message: t(`response_message.min_total_amount`),
              timer: 2000,
              reload: true,
            })
          } else if (response.messages.includes(RETUR_CANNOT_BE_USED_WITH_DP)) {
            showAlert({
              icon: 'error',
              message: t(`response_message.retur_cannot_be_used_with_dp`),
              timer: 2000,
              reload: true,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 2000,
              reload: true,
            })
          }
        }
      })
    },
    [account.full_name, account.uid, navigate, seller.company_uid, t],
  )

  const updateBill = useCallback(
    (payload) => {
      let billPayload = { ...payload }
      setBillLoading(true)
      ApiService.jsonRequest('/fund-bill/update', billPayload, (response) => {
        setBillLoading(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_updated`),
            timer: 2000,
            redirect: `/order/view?uid=${payload.reference_uid}`,
          })
        } else {
          if (response.messages === DATA_ALREADY_EXIST) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 2000,
            })
          }
        }
      })
    },
    [t],
  )

  return { billList, billData, billPage, viewBill, addBill, updateBill, billLoading }
}

export default InteractorFundBill
